import { API_URL_COPILOT } from "~/constants/url";
import { IAlert } from "~/types/alert";
import { BaseApi } from "./baseApi";

const copilotRequest = BaseApi({ baseUrl: API_URL_COPILOT });

export const getNotificationHistory = async () => {
  const notifications = await copilotRequest<IAlert[]>({
    action: "alertHistory",
    method: "GET",
  });

  const sortedNotifications = notifications.sort((a, b) => {
    const dateA = a.operationDate ? new Date(a.operationDate).getTime() : 0;
    const dateB = b.operationDate ? new Date(b.operationDate).getTime() : 0;
    return dateB - dateA;
  });

  return sortedNotifications;
};
